var render, staticRenderFns
import script from "./ErrorBoundary.vue?vue&type=script&lang=js&"
export * from "./ErrorBoundary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561155b8",
  null
  
)

export default component.exports